import React, { useContext } from "react";
import Footer from "./footer";
import { Link } from 'react-router-dom';
import { useState,useEffect } from "react";
import TdsPp from "./Tdspp";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";


function Tdsreturnfiling() {

    const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();

    const toggleQuestion = (questionId) => {
        setActiveQuestion((prev) => (prev === questionId ? null : questionId));
    };



const [plans, setPlans] = useState([]);
const [option1Plans, setOption1Plans] = useState([]);
const [selectedOption, setSelectedOption] = useState("option1");


    const [selecttrue1, setSelectrue1] = useState("");
    const [selecttrue2, setSelectrue2] = useState("");
    const [selecttrue3, setSelectrue3] = useState("");
    const [selecttrue4, setSelectrue4] = useState("");

   const handleChange = async (e) => {
  const value = e.target.value;
  setSelectedOption(value);

  try {
    const response = await http.get("/service-plans", {
      params: {
        service_id: 17,
        group_key: value
      }
    });

    if (response.data.success) {
      setPlans(response.data.plans);
    } else {
      setPlans([]);
    }
  } catch (error) {
    console.log(error);
    setPlans([]);
  }
};


// useEffect(() => {
//   const loadDefault = async () => {
//     try {
//       const response = await http.get("/service-plans", {
//         params: { service_id: 17, group_key: "option1" }
//       });
//       if (response.data.success) setPlans(response.data.plans);
//     } catch (e) {
//       console.log(e);
//     }
//   };
//   loadDefault();
// }, []);/

useEffect(() => {
  const loadDefault = async () => {
    try {
      const response = await http.get("/service-plans", {
        params: {
          service_id: 17,
          group_key: "option1",
        },
      });

      if (response.data.success) {
        setPlans(response.data.plans);
        setOption1Plans(response.data.plans);
      } else {
        setPlans([]);
        setOption1Plans([]);
      }
    } catch (error) {
      console.log(error);
      setPlans([]);
      setOption1Plans([]);
    }
  };

  loadDefault();
}, []);






const startingPrice = option1Plans.find(
  (plan) => Number(plan.sort_order) === 1
)?.price;

    const [activeTab, setActiveTab] = useState(1);
    const showContent = (tabId) => {
        setActiveTab(tabId);
    };

    const showInputTag = (value) => {
        if (value === "1") {
            setSelectrue1("1");
        }
        else if (value === "2") {
            setSelectrue2("2");
        }
        else if (value === "3") {
            setSelectrue3("3");
        }
        else if (value === "4") {
            setSelectrue4("4");
        }

    };

    const handleBannerClick = () => {
  const scrollToElement = document.querySelector(".price-heading");
 

  // 1️⃣ Scroll to .price-heading
  if (scrollToElement) {
    scrollToElement.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }

};



    const [isFormVisible, setIsFormVisible] = useState(false);

    const toggleFormVisibility = () => {
        setIsFormVisible(!isFormVisible);
    };

    const starterPlan = {
        title: "Starter",
        price: "2250",
        oldPrice: "2813.00",
        discount: 25,
        requirements: [
            "Pdf file of Paid Challan",
            "Data maintained in Excel Desired format",
        ],
        inclusions: [
            "Dashboard for managing service",
            "Mobile application support",
            "Documents sharing facility",
            "Download deliverables any time",
            "Password sharing",
            "Round the clock support",
            "Time to time updates & notifications",
        ],
    };

    const starterPlan1 = {
        title: "Basic",
        price: "3250",
        oldPrice: "4063.75",
        discount: 25,
        requirements: [
            'Online Challan Payment Assistance',
            'Data maintained in Excel Desired format',
        ],
        inclusions: [
            'E-way bill facility',
            'Dashboard for managing service',
            'Mobile application support',
            'Documents sharing facility',
            'Download deliverables any time',
            'Password sharing',
            'Round the clock support',
            'Time to time updates & notifications',
        ],
    };


    const starterPlan2 = {

        title: "Starter",
        price: "7250",
        oldPrice: "9063.00",
        discount: 25,
        requirements: [
            'Pdf file of Paid Challan',
            'Data maintained in Excel Desired format',
        ],
        inclusions: [
            'Dashboard for managing service',
            'Mobile application support',
            'Documents sharing facility',
            'Download deliverables any time',
            'Password sharing',
            'Round the clock support',
            'Time to time updates & notifications',
        ],
    };
    const starterPlan3 = {

        title: "Basic",
        price: "12250",
        oldPrice: "15313.75.00",
        discount: 25,
        requirements: [
            'Online Challan Payment Assistance',
            'Data maintained in Excel Desired format',
        ],
        inclusions: [
            'E-way bill facility',
            'Dashboard for managing service',
            'Mobile application support',
            'Documents sharing facility',
            'Download deliverables any time',
            'Password sharing',
            'Round the clock support',
            'Time to time updates & notifications',
        ],
    };
    const starterPlan4 = {

        title: "Starter",
        price: "24250",
        oldPrice: "30313.75.00",
        discount: 25,
        requirements: [
            'Pdf file of Paid Challan',
            'Data maintained in Excel Desired format',
        ],
        inclusions: [
            'Dashboard for managing service',
            'Mobile application support',
            'Documents sharing facility',
            'Download deliverables any time',
            'Password sharing',
            'Round the clock support',
            'Time to time updates & notifications',
        ],
    };
    const starterPlan5 = {

        title: "Starter",
        price: "36250",
        oldPrice: "45313.75.00",
        discount: 25,
        requirements: [
            'Pdf file of Paid Challan',
            'Data maintained in Excel Desired format',
        ],
        inclusions: [
            'Dashboard for managing service',
            'Mobile application support',
            'Documents sharing facility',
            'Download deliverables any time',
            'Password sharing',
            'Round the clock support',
            'Time to time updates & notifications',
        ],
    };

    const [newData, setNewData] = useState({ user_name: '', user_designation: '', user_email: '', user_contact_number: '', user_related_query: '' })


    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};

        if (!newData.user_name.trim()) {
            newErrors.user_name = 'Name is required.';
        } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
            newErrors.user_name = '*Name should only contain letters and spaces.';
        }
        if (!newData.user_designation.trim()) {
            newErrors.user_designation = 'Name is required.';
        } else if (!/^[a-zA-Z\s]+$/.test(newData.user_designation)) {
            newErrors.user_name = '*Name should only contain letters and spaces.';
        }

        if (!newData.user_email.trim()) {
            newErrors.user_email = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
            newErrors.user_email = 'Enter a valid email address.';
        }

        if (newData.user_contact_number && !/^\d{10}$/.test(newData.user_contact_number)) {
            newErrors.user_contact_number = 'Enter a valid 10-digit contact number.';
        }

        if (!newData.user_related_query) {
            newErrors.user_related_query = 'This field required.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // No errors
    };





      const formPutPartenshipdeed = async (e) => {
                        e.preventDefault();
                        if (!validateForm()) return;
                      
                        await handleRazorpayPayment({
                           service,
                           userData: newData,
                           http, // ✅ Pass this from the component
                           fieldMap: {
                               email: newData.user_email ? 'user_email' : 'user_email_address',
                               contact: newData.user_contact_number ? 'user_contact_number' : 'user_phone_number',
                               name: newData.user_name ? 'user_name' : 'full_name'
                             }
                             ,
                           formSubmitCallback: async (mergedData) => {
                             await PartenerSheepDeedService.tdsReturnForm(mergedData);
                             setNewData({
                                user_name: '',
                                user_email: '',
                                user_contact_number: '',
                                user_related_query: '',
                                user_designation: '',
                            });
                           },
                         });
                         
                      };


    const [receivedData, setReceivedData] = useState(null);

    const handleDataFromChild = (data) => {
        console.log("Data received from child:", data);
        setReceivedData(data);
    };

       const { services, loading, error } = useContext(ServicesContext);  
       if (loading) {
          return <div>Loading...</div>;  // Show loading state while fetching data
      }
    
      if (error) {
           return <div>{error}</div> // Show error state if there was an issue fetching data
      }
       const service = services.find(s => s.service_id === 17);


    return (
        <>

             <div className="hero-section">
             <div className="container">
               <div className="row hero-row">
           
                 <div className="col-lg-8 hero-left">
                          <div class="title title2">
                       <h1 class="sk-text-color">TDS Return Filing</h1>
           
           
<p className="pdrl-text">
  Start with Only{" "}
  <span className="text-color">
    {startingPrice != null
      ? `₹${Number(startingPrice).toLocaleString("en-IN")}/-`
      : "Loading..."}
  </span>
</p>                
           
                    <p className="pd-text">
                    Dm2Legal’s expert team specializes in TDS return filing, ensuring timely and accurate submissions. As a mandatory quarterly requirement, 
                    filing TDS returns on time helps avoid penalties and ensures compliance. Our fully online service simplifies the process, keeping you stress-free and compliant. 
                    Trust our professionals to handle your tax obligations efficiently while you focus on growing your business.
                   </p>
           
                   <div className="btn-group">
                                                       <Link to="/contactus" className="theme-btn-3 btn-color ">
                                                           Schedule A Call <span><i className="fa-solid fa-arrow-right"></i></span>
                                                       </Link>
                                   </div>
                                   <div className="space30"></div>
           
                   {/* <div className="hero-link">
                     <a href="/gst-registration">Know more about TDS Return Filing</a>
                   </div> */}
                   <div className="banner" onClick={handleBannerClick}>
                                      <img src="assets/icons/banner.svg" alt="" />
                                   </div>
                                   </div>
                 </div>
           
                 <div className="col-lg-4 hero-right">
                    <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" /> 
                   <img src="assets/img/images/guy1.png" alt="TDS return Filing" />
                 </div>
           
               </div>
             </div>
           </div>
           
            <div className="space80"></div>





            <div className="home4-counters bg-white">
                <div className="space50"></div>
                <div className="container">
                    <div className="row">

                        <div className="col-lg-8">

                            <h2>About TDS Return Filing</h2>

                            <p className="pd-text">TDS (Tax Deducted at Source) return filing is a vital financial responsibility in India, ensuring proper tax collection and compliance. By accurately reporting tax deductions at the source, businesses contribute to transparency and efficient taxation.

                                At Dm2Legal, our team of experts simplifies the TDS return filing process, handling all complexities of India’s tax regulations to ensure timely and error-free submissions. With our professional support, you can stay compliant, avoid penalties, and focus on growing your business while we take care of your tax obligations.

                                Partner with Dm2Legal today for seamless, reliable, and expert TDS return filing services!</p>
                        </div>
                        <div className="col-lg-4">

                            <div className="contact6-list doc-list">
                                <img src="assets/img/images/About-TDS-Return-Filing.png" alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">

                                <h2 className="aos-init aos-animate text-center">Plans</h2>
                            </div>
                            <p className="pd-text text-center">Please select Number of Parties / Deductites Quarterly :</p>
                            <div className="price-heading">
                                <select id="dropdown" onChange={handleChange}>
                                    <option value="option1">0 to 50 Parties / Deductites</option>
                                    <option value="option2">50 to 250 Parties / Deductites</option>
                                    <option value="option3">250 to 500 Parties / Deductites</option>
                                    <option value="option4">500 to 800 Parties / Deductites</option>
                                    <option value="option5">800 Parties / Deductites Above</option>
                                </select>
                            </div>
                            &nbsp;
                            {selectedOption !== "option5" && (
  <div className="box-container">
    <div className="container">
      <div className="row box-center">
        {plans.map((plan) => (
          <div className="col-md-3 col-sm-6" key={plan.id}>
            <TdsPp
              title={plan.title}
              price={parseFloat(plan.price)}
              oldPrice={plan.meta?.oldPrice}
              discount={plan.meta?.discount}
              requirements={plan.meta?.requirements || []}
              inclusions={plan.meta?.inclusions || []}
              onSubmit={handleDataFromChild}
            />
          </div>
        ))}
      </div>
    </div>
  </div>
)}


                            {selectedOption === "option5" && (<div className="box-container" id="option5-boxes">
                                <div className="container">
                                    <div className="row box-center">
                                        <div className="col-md-3 col-sm-6">
                                            <div className="pricing-plan">
                                                <p className="pp-text">Enterprise Solution</p>
                                                <div className="formContainer ">
                                                    <form>
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" placeholder="Contact Person Name"
                                                                required value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                                            {errors.user_name && <p className="error">{errors.user_name}</p>}
                                                        </div>
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" placeholder="Contact Person Designation" required value={newData.user_designation} onChange={(e) => setNewData({ ...newData, user_designation: e.target.value })} />
                                                            {errors.user_designation && <p className="error">{errors.user_designation}</p>}
                                                        </div>
                                                        <div className="form-group">
                                                            <input type="email" className="form-control" placeholder="Email" required value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                                                            {errors.user_email && <p className="error">{errors.user_email}</p>}
                                                        </div>
                                                        <div className="form-group">
                                                            <input type="tel" className="form-control" placeholder="Contact No." required value={newData.user_contact_number} onChange={(e) => setNewData({ ...newData, user_contact_number: e.target.value })} />
                                                            {errors.user_contact_number && <p className="error">{errors.user_contact_number}</p>}
                                                        </div>
                                                        <div className="form-group">
                                                            <input type="text" className="form-control"
                                                                placeholder="Tentative Parties Quarterly" required onChange={(e) => setNewData({ ...newData, user_related_query: e.target.value })} value={newData.user_related_query} />
                                                            {errors.user_related_query && <p className="error">{errors.user_related_query}</p>}
                                                        </div>
                                                        <button type="submit" className="getStartedBtn btn btn-light" onClick={formPutPartenshipdeed}>Submit</button>
                                                    </form>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>)}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">
                                <h2 className="text-center">How to apply</h2>
                                <div className="space30"></div>
                                <img src="assets/img/images/legal251-how-to-apply.png" alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="space40"></div>
                </div>
            </div>




            <div className="service-binifits9 sp0" id="service2">
                <div className="space50"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">
                                <h2 className="text-center">Types of forms</h2>
                            </div>
                        </div>
                        <div className="space40"></div>

                        <div className="tabs">
                            <div className="tab-row">
                                <div
                                    className={`tab ${activeTab === 1 ? 'active-tab' : ''}`}
                                    onClick={() => showContent(1)}
                                >
                                    Form 24Q
                                </div>
                                <div
                                    className={`tab ${activeTab === 2 ? 'active-tab' : ''}`}
                                    onClick={() => showContent(2)}
                                >
                                    Form 27Q
                                </div>
                                <div
                                    className={`tab ${activeTab === 3 ? 'active-tab' : ''}`}
                                    onClick={() => showContent(3)}
                                >
                                    Form 26Q
                                </div>
                                <div
                                    className={`tab ${activeTab === 4 ? 'active-tab' : ''}`}
                                    onClick={() => showContent(4)}
                                >
                                    Form 27EQ
                                </div>
                            </div>
                        </div>

                        <div className="space30"></div>



                        <div className="contents">
                            {activeTab === 1 && (
                                <div className="content" id="content1">
                                    <h2>Form 24Q</h2>
                                    <p className="pd-text">Form 27EQ is required for TDS on payments made to non-resident sportsmen or
                                        entertainers. This specific area requires meticulous attention, and the expert team at Dm2Legal
                                        is highly skilled in managing Form 27EQ, ensuring accurate handling, compliance, and smooth
                                        filing.</p>
                                </div>
                            )}
                            {activeTab === 2 && (
                                <div className="content" id="content2">
                                    <h2>Form 27Q</h2>
                                    <p className="pd-text">Form 27Q is essential for TDS on payments made to non-residents, as it records
                                        the tax deductions on such transactions. Trust Dm2Legal's experienced team to expertly handle
                                        Form 27Q, simplifying the TDS deduction process for non-resident payments.</p>
                                </div>
                            )}
                            {activeTab === 3 && (
                                <div className="content" id="content3">
                                    <h2>Form 26Q</h2>
                                    <p className="pd-text">Form 26Q is used for TDS on payments other than salaries, covering transactions
                                        such as rent, interest, and professional fees. Dm2Legal's skilled team specializes in filing
                                        Form 26Q, ensuring accurate reporting of all non-salary TDS deductions.</p>
                                </div>
                            )}
                            {activeTab === 4 && (
                                <div className="content" id="content4">
                                    <h2>Form 27EQ</h2>
                                    <p className="pd-text">Form 27EQ is required for TDS on payments made to non-resident sportsmen or
                                        entertainers. This specialized area requires meticulous attention, and Dm2Legal's expert team is
                                        highly skilled in managing Form 27EQ, ensuring accurate filing and compliance.</p>
                                </div>
                            )}
                        </div>
                        <div className="space80"></div>
                    </div>

                </div>
            </div>



            <div className="service-binifits9 sp0">
                <div className="space40"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">
                                <h2 className="text-center">Benefits </h2>
                                <div className="service-binifits-boxs">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong> Legal Compliance </strong></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Financial Transparency</strong>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Government Revenue</strong></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Penalty Avoidance</strong></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Comprehensive Records</strong>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Smooth Business
                                                        Operations</strong></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Compliance Confidence</strong>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Reduced Tax Liability</strong>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> <strong>Seamlessness in
                                                        Transactions</strong></p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="space30"></div>
                    </div>
                </div>
            </div>
            <div className="space20"></div>

            <div className="service-binifits9 sp0 last-section " id="service2">
                <div className="space50"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 ">
                            <div className="hadding7">
                                <h2 className="text-center">Filing process </h2>
                                <div className="partnership-deade-section">
                                    <div className="space40"></div>
                                    <ul className="disc-list">
                                        <li><h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Our team will carefully review the documents you have submitted, identifying any
                                                inaccuracies or errors to ensure your peace of mind.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li>
                                            <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Our top experts are here to handle your document requirements and ensure your return
                                                filing needs are met.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li><h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>Based on the details you provide, our experts will manage the entire process, from
                                                collecting comprehensive information about deductors and deductions to accurately
                                                reporting the data.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li><h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                            <span>The relevant experts will review your documents and proceed with filing your TDS
                                                Return.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                        <li><h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                                            <span>You will need to wait until our experts contact you to update you on the status of
                                                your filed TDS return.</span>
                                            <svg className="pointer">
                                                <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                            </svg>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                        <div className="space80"></div>
                    </div>
                </div>
            </div>






            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="faq-items" id="masonry-grid">
                            <div className="mesonry-item general single-price-list">
                                <div className="faqs inner-faq">
                                    <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                                    <div className="space30"></div>

                                    <div id="general">


                                        <div className="single-faq">
                                            <h2
                                                className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                                    }`}
                                                id="faq-heading1"
                                                onClick={() => toggleQuestion(1)}
                                            >
                                                Q1: What does filing a TDS return involve?
                                                <span>
                                                    {activeQuestion === 1 ? (
                                                        <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                    ) : (
                                                        <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                    )}
                                                </span>
                                            </h2>
                                            <div
                                                id="collapse1"
                                                className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                                    }`}
                                            >
                                                <p className="font-f-3 weight-500">
                                                    Filing a TDS return involves reporting the tax deducted at the source of payments like salary or contract work to the government. The return provides a summary of the amount of tax deducted and submitted to the authorities.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="single-faq">
                                            <h2
                                                className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                                    }`}
                                                id="faq-heading1"
                                                onClick={() => toggleQuestion(2)}
                                            >
                                                Q2: Who must file TDS returns?
                                                <span>
                                                    {activeQuestion === 2 ? (
                                                        <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                    ) : (
                                                        <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                    )}
                                                </span>
                                            </h2>
                                            <div
                                                id="collapse1"
                                                className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                                    }`}
                                            >
                                                <p className="font-f-3 weight-500">
                                                    Entities or individuals who deduct tax at source, such as employers or business owners making payments that fall under TDS provisions, are required to file TDS returns.                                                </p>
                                            </div>
                                        </div>
                                        <div className="single-faq">
                                            <h2
                                                className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                                    }`}
                                                id="faq-heading1"
                                                onClick={() => toggleQuestion(3)}
                                            >
                                                Q3:What are the different types of TDS return forms?
                                                <span>
                                                    {activeQuestion === 3 ? (
                                                        <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                    ) : (
                                                        <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                    )}
                                                </span>
                                            </h2>
                                            <div
                                                id="collapse1"
                                                className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                                    }`}
                                            >
                                                <p className="font-f-3 weight-500">
                                                    The types of TDS return forms include:<br />

                                                    Form 24Q: For TDS on salary payments.<br />
                                                    Form 26Q: For TDS on payments other than salaries.  
                                                    Form 27Q: For TDS on payments to non-residents.<br />
                                                    Form 27EQ: For TDS on sale of property.<br />
                                                    These forms are used based on the nature of payment and deduction.                                                </p>
                                            </div>
                                        </div>
                                        <div className="single-faq">
                                            <h2
                                                className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                                    }`}
                                                id="faq-heading1"
                                                onClick={() => toggleQuestion(4)}
                                            >
                                                Q4:When should TDS returns be filed?
                                                <span>
                                                    {activeQuestion === 4 ? (
                                                        <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                    ) : (
                                                        <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                    )}
                                                </span>
                                            </h2>
                                            <div
                                                id="collapse1"
                                                className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                                    }`}
                                            >
                                                <p className="font-f-3 weight-500">
                                                    TDS returns should be filed quarterly:<br />

                                                    Q1 (April - June): By July 31<br />
                                                    Q2 (July - September): By October 31<br />
                                                    Q3 (October - December): By January 31<br />
                                                    Q4 (January - March): By May 31<br />
                                                    The due date may vary if it falls on a holiday or weekend.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="single-faq">
                                            <h2
                                                className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                                    }`}
                                                id="faq-heading1"
                                                onClick={() => toggleQuestion(5)}
                                            >
                                                Q5: What role does Dm2Legal play in TDS return filing?
                                                <span>
                                                    {activeQuestion === 5 ? (
                                                        <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                    ) : (
                                                        <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                    )}
                                                </span>
                                            </h2>
                                            <div
                                                id="collapse1"
                                                className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                                    }`}
                                            >
                                                <p className="font-f-3 weight-500">
                                                    Dm2Legal's expert team helps with accurate data collection, form preparation, timely submission, and ensures compliance throughout the entire TDS return filing process.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="single-faq">
                                            <h2
                                                className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                                    }`}
                                                id="faq-heading1"
                                                onClick={() => toggleQuestion(6)}
                                            >
                                                Q6: What are the consequences of not filing TDS returns?
                                                <span>
                                                    {activeQuestion === 6 ? (
                                                        <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                    ) : (
                                                        <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                    )}
                                                </span>
                                            </h2>
                                            <div
                                                id="collapse1"
                                                className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                                    }`}
                                            >
                                                <p className="font-f-3 weight-500">
                                                Failure to file TDS returns on time can result in penalties, interest charges, and legal action. The taxpayer may also face issues like disallowance of expenses, tax audits, and restrictions on the ability to apply for loans or tenders.</p>
                                            </div>
                                        </div>
                                        <div className="single-faq">
                                            <h2
                                                className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                                    }`}
                                                id="faq-heading1"
                                                onClick={() => toggleQuestion(7)}
                                            >
                                                Q7: What happens if TDS returns are filed incorrectly?
                                                <span>
                                                    {activeQuestion === 7 ? (
                                                        <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                    ) : (
                                                        <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                    )}
                                                </span>
                                            </h2>
                                            <div
                                                id="collapse1"
                                                className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                                    }`}
                                            >
                                                <p className="font-f-3 weight-500">
                                                Incorrect TDS return filing can lead to penalties, interest on unpaid dues, and legal consequences. It may also result in a delay in processing the returns, disallowance of deductions, and potential scrutiny from tax authorities                                                </p>
                                            </div>
                                        </div>

                                        <div className="single-faq">
                                            <h2
                                                className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                                    }`}
                                                id="faq-heading1"
                                                onClick={() => toggleQuestion(8)}
                                            >
                                                Q8:Is it possible to revise TDS returns?
                                                <span>
                                                    {activeQuestion === 8 ? (
                                                        <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                    ) : (
                                                        <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                    )}
                                                </span>
                                            </h2>
                                            <div
                                                id="collapse1"
                                                className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                                    }`}
                                            >
                                                <p className="font-f-3 weight-500">
                                                Yes, TDS returns can be revised if there is an error or omission in the original filing. A revised return must be filed within the time limit set by the Income Tax Department to correct mistakes and avoid penalties.

                                                      </p>
                                            </div>
                                        </div>

                                        <div className="single-faq">
                                            <h2
                                                className={`faq-heading font-f-3 weight-700 ${activeQuestion === 9 ? '' : 'collapsed'
                                                    }`}
                                                id="faq-heading1"
                                                onClick={() => toggleQuestion(9)}
                                            >
                                                Q9: What documents are required for filing TDS returns?
                                                <span>
                                                    {activeQuestion === 9 ? (
                                                        <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                    ) : (
                                                        <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                    )}
                                                </span>
                                            </h2>
                                            <div
                                                id="collapse1"
                                                className={`accordion-collapse collapse ${activeQuestion === 9 ? 'show' : ''
                                                    }`}
                                            >
                                                <p className="font-f-3 weight-500">
                                                    The documents needed for TDS return filing include the PAN of both the deductor and deductee, TDS challans, TDS certificates (Form 16/16A), transaction details, and any other documents relevant to the nature of the payments.
                                                </p>
                                            </div>
                                        </div>

                                        <div className="single-faq">
                                            <h2
                                                className={`faq-heading font-f-3 weight-700 ${activeQuestion === 10 ? '' : 'collapsed'
                                                    }`}
                                                id="faq-heading1"
                                                onClick={() => toggleQuestion(10)}
                                            >
                                                Q10: Can TDS returns be filed manually or is online filing mandatory?
                                                <span>
                                                    {activeQuestion === 10 ? (
                                                        <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                    ) : (
                                                        <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                    )}
                                                </span>
                                            </h2>
                                            <div
                                                id="collapse1"
                                                className={`accordion-collapse collapse ${activeQuestion === 10 ? 'show' : ''
                                                    }`}
                                            >
                                                <p className="font-f-3 weight-500">
                                                TDS returns must be filed online with the Income Tax Department through the TRACES portal. Manual filing is not allowed for TDS returns. The online process ensures quicker processing and compliance.                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="space30"></div>
                <Testimonials />
            </div>


            <div className="last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">
                <div className="space20"></div>
                <h2 className="aos-init aos-animate">Why Choose Us?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                  <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                  <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                  <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                  <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                  <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                  <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
            <div className="space80"></div>
            <WhatsAppScrollButton />

            <Footer />

            <CircularScrollProgress />

        </>
    );
}
export default Tdsreturnfiling;
